import { takeLatest, put, call } from 'redux-saga/effects'
import * as CONST from './const'
import * as ERRORS from 'Reducers/Errors/const'
import { apiClient } from 'Module/API/Client'
import NProgress from 'nprogress'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'

/**
 * Create a job
 * @param {Object} action
 */
function* createJob(action) {
  yield put(incUIBlockCounter())
  NProgress.start()

  const { jobParams, callbacks } = action
  try {
    const response = yield call(apiClient.createJob, jobParams)
    const responseJson = yield response.json()
    if (response.status !== 200) {
      var error = new Error(
        responseJson.message || 'Create job was not successful.',
      )
      // Add the details
      if (responseJson.error)
        error.message += ' ' + JSON.stringify(responseJson.error, null, 2)
      throw error
    }
    yield put({
      type: CONST.CREATE_JOB_SUCCESS,
    })
    if (callbacks && callbacks.onSuccess) callbacks.onSuccess()
  } catch (ex) {
    console.error(ex)
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Watch create job
 */
export function* watchCreateJob() {
  yield takeLatest(CONST.CREATE_JOB, createJob)
}
